export const graphqlEndpoint = `${process.env.EXPO_PUBLIC_API_BASE_URL}/graphql` as const
